import { MedicalEmergencyCreateType } from "../../components/main/body/screens/EMS/MedicalEmergencyCreate/MedicalEmergencyCreateType";
import { MedicalEmergencyNotesType } from "../../components/main/body/screens/MedicalEmergenciesMainScreen/MedicalEmergencyDetails/NotesType";
import HmsVideocallManager from "../../util/100ms/HmsVideocallManager";
import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import { DiversionDecisionStatus } from "../flights/typings/IFlightResponse";
import PassengerService from "../passenger/passenger.service";
import {
  IMedicalEmergencyApiResponse,
  MedicalEmergencyStatus,
} from "./typings/IMedicalEmergencyApiResponse";
import { MedicalEmergencyWithPassengerType } from "./typings/MedicalEmergencyWithPassengerType";

export default class MedicalEmergencyService {
  static async listMedicalEmergencies(isAdmin?: boolean) {
    const apiConfig = {
      api: APIs.MedicalEmergency.ListMedicalEmergency,
      parameters: {
        "user-admin": isAdmin !== undefined ? isAdmin : ""
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IMedicalEmergencyApiResponse[];
  }

  static async listMedicalEmergenciesByEms(emsId: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.GetMedicalEmergenciesByEmsId,
      parameters: {
        "ems-id": emsId,
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IMedicalEmergencyApiResponse[];
  }

  static getVideocallRecordForMedicalEmergency = async (
    medicalEmergencyId: number,
    signal?: AbortSignal
  ) => {
    const apiConfig = {
      api: APIs.Videcall.ListAllByMedicalEmergencyId,
      parameters: {
        "medical-emergency-id": medicalEmergencyId.toString(),
      },
      body: null,
      signal,
    };

    try {
      const response = await SafeairManager.invoke(apiConfig);
      console.log("response from videocall", response);
      if (
        response != null &&
        response.data != null &&
        response.data.length > 0
      ) {
        const videocallRecord = response.data[response.data.length - 1];
        return videocallRecord;
      } else {
        throw new Error("Failed to get videocall");
      }
    } catch (e) {
      console.log("error while vc", e);
    }
  };

  static getMedicalEmergency = async (medicalEmergencyId: string) => {
    const apiConfig = {
      api: APIs.MedicalEmergency.GetMedicalEmergency,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IMedicalEmergencyApiResponse;
  };

  static updateMedicalEmergencyNotes = async (medicalEmergencyId: number, notes: any) => {
    const apiConfig = {
      api: APIs.MedicalEmergency.GetMedicalEmergencyNotes,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
      body: 
      {
        id: medicalEmergencyId,
        emsNotes:notes
      },
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IMedicalEmergencyApiResponse;
  };

  static getMedical = async (medicalEmergencyId: string) => {
    const apiConfig = {
      api: APIs.Medical.getMedicalKit,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
      body: null,
    };

    const response = await SafeairManager.invoke(apiConfig);

    return response.data;
  };

  static getMedicalKitItems = async (flightId: string) => {
    const apiConfig = {
      api: APIs.Medical.getMedicalKitList,
      parameters: {
        "flightId": flightId
      },
      body: null
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data
  }
  

  static getNotified = async (medicalEmergencyId: string) => {
    const apiConfig = {
      api: APIs.Medical.getNotify,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  };

  static getFcmToken = async () => {
    const apiConfig = {
      api: APIs.Medical.getFcmToken,
      parameters: null,
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  };

  static async getSideKit(medicalEmergencyId: number, medicalKitId: number) {
    const apiConfig = {
      api: APIs.Medical.getSideData,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
        "medicalKit": medicalKitId
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async getAdd(description:string,KitId:string,medicalEmergencyId:number,itemId: number) {
    const apiConfig = {
      api: APIs.Medical.getAddData,
      parameters:{
        "description":description,
        "KitId":KitId,
        "medical-emergency-id":medicalEmergencyId,
        "itemId":itemId
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async removeData(KitId:string,medicalEmergencyId:number,itemId: number) {
    const apiConfig = {
      api: APIs.Medical.remove,
      parameters:{
        "KitId":KitId,
        "medical-emergency-id":medicalEmergencyId,
        "itemId":itemId
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  // static createVideoCall = async (medicalEmergencyId: string, room: string, captainroom: string, status: string) => {
  static createVideoCall = async (medicalEmergencyId: string, room: string,captainroom: string, status: string) => {
    console.log("medicalEmergencyId+room+captainroom+status",medicalEmergencyId+room+status);
    const apiConfig = {      
      api: APIs.Videcall.CreateRecord,
      parameters: null,
      body: {
        medicalEmergencyId: medicalEmergencyId,
        roomId: room,
        captainRoomId: captainroom,
        status: status
      },
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as IMedicalEmergencyApiResponse;
  };

  /*
    Set status of medical emergency
  */
  static async setMedicalEmergencyStatus(
    medicalEmergencyId: number,
    status: MedicalEmergencyStatus
  ) {
    const apiConfig = {
      api: APIs.MedicalEmergency.UpdateMedicalEmergencyFields,
      parameters: {
        "medical-emergency-id": medicalEmergencyId.toString(),
      },
      body: {
        status: status.toString(),
      },
    };
    await SafeairManager.invoke(apiConfig);
  }

  /*
    Set assignedEms of medical emergency
  */
  static async setMedicalEmergencyEms(
    medicalEmergencyIds: number[],
    emsId: string
  ) {
    const promises = medicalEmergencyIds.map((medicalEmergencyId) =>
      SafeairManager.invoke({
        api: APIs.MedicalEmergency.UpdateMedicalEmergencyFields,
        parameters: {
          "medical-emergency-id": medicalEmergencyId.toString(),
        },
        body: {
          assignedEms: emsId,
        },
      })
    );

    await Promise.all(promises);
  }

  static async setSingleMedicalEmergencyEms(
    medicalEmergencyIds: number,
    emsId: string
  ) {
      SafeairManager.invoke({
        api: APIs.MedicalEmergency.UpdateMedicalEmergencyFields,
        parameters: {
          "medical-emergency-id": medicalEmergencyIds,
        },
        body: {
          assignedEms: emsId,
        },
      })
  }
  static async listMedicalEmergencyWithPassengersByEms(emsId: string) {
    // const medicalEmergencyWithPassengerPromiseList = (
    //   await this.listMedicalEmergenciesByEms(emsId)
    // ).map(async (emergency) => {
    //   const passenger = await PassengerService.getPassenger(
    //     emergency.passengerId
    //   );
    //   return {
    //     ...emergency,
    //     ...(passenger ? { passenger: passenger } : {}),
    //   };
    // });
    // return await Promise.all(medicalEmergencyWithPassengerPromiseList);
    return await this.listMedicalEmergenciesByEms(emsId);
  }

  static async updateNotes(notes: string, medicalEmergencyId: number) {
    const apiConfig = {
      api: APIs.MedicalEmergency.UpdateMedicalEmergencyFields,
      parameters: {
        "medical-emergency-id": medicalEmergencyId.toString(),
      },
      body: {
        notes,
      },
    };
    await SafeairManager.invoke(apiConfig);
  }

  static async updateNotificationShow(
    medicalEmergencyId: number,
    notificationShow: string
  ) {
    const apiConfig = {
      api: APIs.MedicalEmergency.UpdateMedicalEmergencynotificationEnabler,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
        "notification-Show": notificationShow.toString(),
      },
      body: {},
    };
    await SafeairManager.invoke(apiConfig);
  }
  static async recordCallStart(roomid: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.recordCall,
      parameters: null,
      body: {
        roomid,
      },
    };
    return await SafeairManager.invoke(apiConfig);
  }
  static async recordCallStop(roomid: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.recordCallStop,
      parameters: null,
      body: {
        roomid,
      },
    };
    return await SafeairManager.invoke(apiConfig);
  }
  static async recommendDiversion(medicalEmergencyId: number) {
    const apiConfig = {
      api: APIs.MedicalEmergency.UpdateMedicalEmergencyDiversionStatus,
      parameters: {
        "medical-emergency-id": medicalEmergencyId,
      },
      body: {
        diversion: DiversionDecisionStatus.DIVERSION_REQUIRED
      },
    };
    const response = await SafeairManager.invoke(apiConfig);
    console.log("recommendDiversion in medicalEmergencyServices",response)
    return response.data;
  }

  static async getCrewList() {
    const apiConfig = {
      api: APIs.Crew.crewList,
      parameters: null,
      body: null
    };
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }

  static async createPassenger(ordId: string,name?: string, age?: number, gender?: string) {
    const apiConfig = {
      api: APIs.Passenger.CreatePassenger,
      parameters: null,
      body: {
        orgId: ordId,
        name: name,
        age: age,
        gender: gender
      }
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res; 
  }

  static async getCrewLocation(crewName: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.getCrewCurrentLocation,
      parameters: {
        "crewName": crewName
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data
  }

  static async createMedicalEmergency(medicalEmergency : MedicalEmergencyCreateType) {
    console.log("create medical", medicalEmergency);
    const apiConfig = {
      api: APIs.MedicalEmergency.CreateMedicalEmergency,
      parameters: null,
      body: medicalEmergency
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }
  
  static async getNewIncident() {
    const apiConfig = {
      api: APIs.MedicalEmergency.getNewlyIncident,
      parameters: null,
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }

  static async getUserActivity() {
    const apiConfig = {
      api: APIs.MedicalEmergency.UserActivity,
      parameters: null,
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }

  static async getActiveIncident(order:string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.getActiveIncident,
      parameters: {
        order: order
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }

  static async getUserActivityHistory(fromdate: string, todate: string, projectId: number, limit: number) {
    const apiConfig = {
      api: APIs.MixPannel.ActivityHistory,
      parameters: {
        "fdate": fromdate,
        "tdate": todate,
        "projId": projectId,
        "limit": limit // <-- pass limit dynamically
      },
      body: null
    };
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }

  static async getActivity(ems: string, incidentIds: string, order:string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.getActivity,
      parameters: {
        assignedEms: ems,
        medicalIncidentIds: incidentIds,
        order: order
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }

  static async getAdminActivity(fromData: string, toDate: string, projectId: number) {
    const apiConfig = {
      api: APIs.MedicalEmergency.getAdminActivity,
      parameters: {
        fdate: fromData,
        tdate: toDate,
        projId: projectId
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }

  static async requestToReportUpload(meId: string, vitalType: string) {
    const apiConfig = {
      api: APIs.MedicalEmergency.requestReport,
      parameters: null,
      body: {
        medicalEmergencyId: meId,
        vitalType: vitalType,
        flag: true
      }
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data; 
  }
}
